module.exports = __webpack_public_path__ + "img/whiteBrandFrontPageImg03.3eec186c.jpg";